module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "rate",
    class: _vm.getCssColorClass(_vm.row[_vm.column.data])
  }, [_vm._v(_vm._s(_vm.row[_vm.column.data]))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20cd74de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/CommentRatingHighlightComponent.vue
// module id = 1246
// module chunks = 2